import React from "react";
import { useTranslation } from "react-i18next";

// value: { [leftId]: rightText }
const Matching = ({ question, value = {}, onChange, review }) => {
  const { t } = useTranslation();
  const rights = question.rights || [];

  const setPair = (leftId, rightText) =>
    onChange({ ...value, [leftId]: rightText });

  return (
    <div className="flex flex-col gap-3">
      <p className="text-xs text-lightWhite">{t("quiz.match_hint")}</p>
      {(question.lefts || []).map((left) => (
        <div
          key={left._id}
          className="flex items-center gap-3 flex-col sm:flex-row"
        >
          <span className="w-full sm:w-1/2 px-4 py-3 rounded-lg bg-grey border border-lightGrey text-white">
            {left.text}
          </span>
          <select
            disabled={review}
            value={value[left._id] || ""}
            onChange={(e) => setPair(left._id, e.target.value)}
            className="w-full sm:w-1/2 px-4 py-3 rounded-lg bg-grey border border-lightGrey text-white outline-none focus:border-primary disabled:opacity-60"
          >
            <option value="" disabled>
              {t("quiz.select_answer")}
            </option>
            {rights.map((r, i) => (
              <option key={i} value={r}>
                {r}
              </option>
            ))}
          </select>
        </div>
      ))}
    </div>
  );
};

export default Matching;
